import { createBrowserRouter } from "react-router-dom";
import RootLayout from "../layout/root"
import Home from "../pages/home";
import About from "../pages/about";
import LayoutTwo from "../layout/layoutTwo";
import Contact from "../pages/contact";
import Testimonials from "../pages/testimonials";
import CcwDetails from "../pages/ccw-details";
import WsdDetails from "../pages/wsd-details";
import BlsDetails from "../pages/bls-details";
import K12Details from "../pages/k12-details";
import NotFound from "../pages/404";
import Classes from "../pages/classes";
import Thanks from "../pages/thanks";
import Partners from "../pages/partners";
import PrivacyPolicy from "../pages/privacy-policy";
import CprDetails from "../pages/cpr-details";
import Tp1Details from "../pages/tp1-details";


export const router = createBrowserRouter([
    {
        path: "/",
        element: <RootLayout />,
        errorElement: <NotFound />,
        children: [
            {
                path: "/",
                element: <Home />
            },
        ],
    },
    {
        path: "/",
        element: <LayoutTwo />,
        children:[
            {
                path: "/ccw-details",
                element: <CcwDetails />
            },
            {
                path: "/wsd-details",
                element: <WsdDetails />
            },
            {
                path: "/cpr-details",
                element: <CprDetails />
            },
            {
                path: "/bls-details",
                element: <BlsDetails />
            },
            {
                path: "/k12-details",
                element: <K12Details />
            },
            {
                path: "/tp1-details",
                element: <Tp1Details />
            },
            {
                path: "/contact",
                element: <Contact />
            },
            {
                path: "/about",
                element: <About />
            },
            {
                path: "/thanks",
                element: <Thanks />
            },
            {
                path: "/testimonials",
                element: <Testimonials />
            },
            {
                path: "/classes",
                element: <Classes />   
            },
            {
                path: "/privacy-policy",
                element: <PrivacyPolicy />   
            },
            {
                path: "/partners",
                element: <Partners />   
            },
        ]
    }
])
